import { IIconProps } from '~/types';
const InrFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.25}
      y={0.25}
      width={27.5}
      height={19.5}
      rx={1.75}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
    />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={1.75}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
      />
    </mask>
    <g mask="url(#a)">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 6.667h28V0H0z" fill="#FFA44A" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 20h28v-6.666H0z" fill="#1A9F0B" />
      <path
        d="M14 12.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666Z"
        fill="#181A93"
        fillOpacity={0.15}
        stroke="#181A93"
        strokeWidth={0.667}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333"
        fill="#181A93"
      />
    </g>
  </svg>
);
export default InrFlag;
